import { ChangeContext, Options } from "@angular-slider/ngx-slider";
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as dwv from 'dwv';
import { NgxSelectOption } from 'ngx-select-ex';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from "../../../../../environments/environment"; 
import { RadiologyEhr, RadiologyEhrData } from "../../../../@core/interfaces/ehr/radiology-ehr";

// gui overrides

// get element
dwv.gui.getElement = dwv.gui.base.getElement;
dwv.gui.prompt = dwv.gui.base.prompt;

// Image decoders (for web workers)
dwv.image.decoderScripts = {
  jpeg2000: 'assets/dwv/decoders/jpx-jpeg-codec/decode-jpeg2000.js',
  'jpeg-lossless': 'assets/dwv/decoders/rii-mango/decode-jpegloss.js',
  'jpeg-baseline': 'assets/dwv/decoders/jpx-jpeg-codec/decode-jpegbaseline.js',
  rle: 'assets/dwv/decoders/dwv/decode-rle.js'
};

@Component({
  selector: 'ngx-radiology-ehr-compare',
  templateUrl: './radiology-compare.component.html',
  styleUrls: ['./radiology-compare.component.scss']
})
export class RadiologyCompareComponent implements OnInit {

  protected readonly unsubscribe$ = new Subject<void>();
  toolbarView: boolean = false;
  allowClear: any = true;
  multiple: boolean = false;
  value: number = 0;
  highValue: number = 60;
  @Input() firstFile: RadiologyEhr;
  @Input() secondFile: RadiologyEhr;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  options: Options = {
    floor: 0,
    ceil: 100
  };
  public tools = {
    Scroll: {},
    Filter: {
      options: ["Threshold", "Sharpen", "Sobel"],
      type: "instance",
      events: ["filter-run", "filter-undo"]
    },
    ZoomAndPan: {},
    WindowLevel: {},
    Draw: {
      options: ['Ruler', 'Roi', 'Ellipse', 'Arrow', 'FreeHand', 'Protractor', 'Rectangle'],
      type: 'factory',
      events: ['draw-create', 'draw-change', 'draw-move', 'draw-delete', 'dblclick']
    }
  };
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  public selectedTool = 'Scroll';
  public drawTool = 'Ruler';
  public filterTool = 'Threshold';
  private dwvApp1: any;
  loadProgress: number = 0;
  dataLoaded: boolean = false;
  loadProgress2: number = 0;
  dataLoaded2: boolean = false;
  isSingleView: boolean = false;
  selectedArr: Array<any> = [];
  toolsList: String[] = ["Scroll", "Filter", "ZoomAndPan", "WindowLevel", "Draw"];
  drawoptionList: String[] = ['Ruler', 'Roi', 'Ellipse', 'Arrow', 'FreeHand', 'Protractor', 'Rect'];
  filterList: String[] = ["Threshold", "Sharpen", "Sobel"];
  dataRange: { min: number, max: number };
  regId: any;
  
  private dwvApp2: any;


  constructor(private radiologySrvc: RadiologyEhrData,private route: ActivatedRoute,) { 
    this.route.params.subscribe(params => {
      this.regId = params['regId'];
    });
  }


  ngOnInit(){
    this.dwvApp1 = new dwv.App();
    this.dwvApp2 = new dwv.App();
    // initialise app

    this.dwvApp1.init({
      "containerDivId": "dwv1",
      "fitToWindow": true,
      "gui": ["tool", "load", "help", "undo", "version", "tags", "drawList", "prompt"],
      "loaders": ["File", "Url", "GoogleDrive", "Dropbox"],
      "tools": this.tools,
      "filters": ["Threshold", "Sharpen", "Sobel"],
      "shapes": ["Arrow", "Ruler", "Protractor", "Rectangle", "Roi", "Ellipse", "FreeHand", "Rect"],
    });
    // handle load events
    let nReceivedError = null;
    let nReceivedAbort = null;
    this.dwvApp1.addEventListener('load-start', (/*event*/) => {
      this.dataLoaded = false;
      nReceivedError = 0;
      nReceivedAbort = 0;
    });
    this.dwvApp1.addEventListener('load-progress', (event) => {
      this.loadProgress = event.loaded;
    });
    this.dwvApp1.addEventListener('load', (/*event*/) => {
      // set dicom tags
      // set the selected tool
      let selectedTool = 'Scroll';
      if (this.dwvApp1.isMonoSliceData() &&
        this.dwvApp1.getImage().getNumberOfFrames() === 1) {
        selectedTool = 'ZoomAndPan';
      }
      this.dataRange = this.dwvApp1.getImage().getDataRange();
      this.options.floor = this.dataRange.min;
      this.options.ceil = this.dataRange.max;
      this.highValue = this.dataRange.max;

      this.onChangeToolWithname(selectedTool);

      // set data loaded flag
      this.dataLoaded = true;
    });
    this.dwvApp1.addEventListener('load-end', (/*event*/) => {
      if (nReceivedError) {
        this.loadProgress = 0;
        alert('Received errors during load. Check log for details.');
      }
      if (nReceivedAbort) {
        this.loadProgress = 0;
        alert('Load was aborted.');
      }
    });
    this.dwvApp1.addEventListener('error', (event) => {
      ++nReceivedError;
    });
    this.dwvApp1.addEventListener('abort', (/*event*/) => {
      ++nReceivedAbort;
    });

    // handle key events
    this.dwvApp1.addEventListener('keydown', (event) => {
      this.dwvApp1.defaultOnKeydown(event);
    });
    this.dwvApp1.addEventListener('dblclick', (event) => {

      this.dwvApp1.defaultOnKeydown(event);
    });

    this.dwvApp2.init({
      "containerDivId": "dwv2",
      "fitToWindow": true,
      "gui": ["tool", "load", "help", "undo", "version", "tags", "drawList", "prompt"],
      "loaders": ["File", "Url", "GoogleDrive", "Dropbox"],
      "tools": this.tools,
      "filters": ["Threshold", "Sharpen", "Sobel"],
      "shapes": ["Arrow", "Ruler", "Protractor", "Rectangle", "Roi", "Ellipse", "FreeHand", "Rect"],
    });
    // handle load events
    let nReceivedError2 = null;
    let nReceivedAbort2 = null;
    this.dwvApp2.addEventListener('load-start', (/*event*/) => {
      this.dataLoaded2 = false;
      nReceivedError2 = 0;
      nReceivedAbort2 = 0;
    });
    this.dwvApp2.addEventListener('load-progress', (event) => {
      this.loadProgress2 = event.loaded;
    });
    this.dwvApp2.addEventListener('load', (/*event*/) => {
      // set dicom tags
      // set the selected tool
      let selectedTool = 'Scroll';
      if (this.dwvApp2.isMonoSliceData() &&
        this.dwvApp2.getImage().getNumberOfFrames() === 1) {
        selectedTool = 'ZoomAndPan';
      }
      this.dataRange = this.dwvApp2.getImage().getDataRange();
      this.options.floor = this.dataRange.min;
      this.options.ceil = this.dataRange.max;
      this.highValue = this.dataRange.max;
      this.dwvApp2.setTool(selectedTool);

      // set data loaded flag
      this.dataLoaded2 = true;
    });
    this.dwvApp2.addEventListener('load-end', (/*event*/) => {
      if (nReceivedError2) {
        this.loadProgress2 = 0;
        alert('Received errors during load. Check log for details.');
      }
      if (nReceivedAbort2) {
        this.loadProgress2 = 0;
        alert('Load was aborted.');
      }
    });
    this.dwvApp2.addEventListener('error', (event) => {
      ++nReceivedError2;
    });
    this.dwvApp2.addEventListener('abort', (/*event*/) => {
      ++nReceivedAbort2;
    });

    // handle key events
    this.dwvApp2.addEventListener('keydown', (event) => {
      this.dwvApp2.defaultOnKeydown(event);
    });
    this.dwvApp2.addEventListener('dblclick', (event) => {

      this.dwvApp2.defaultOnKeydown(event);
    });
    // handle window resize
    window.addEventListener('resize', this.dwvApp1.onResize);
    // handle window resize
    window.addEventListener('resize', this.dwvApp2.onResize);

  }


  loadImgs(): void{

    if(this.firstFile != null && this.firstFile != undefined && this.firstFile.fileLocation != "")
    {

      this.firstFile.isCreate = true;
      this.firstFile.isEdit = true;
      this.firstFile.isView = true;
      
      this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`,this.firstFile).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    

        var imgdata = this.base64ToArrayBuffer(data);
     
        this.dwvApp1.loadImageObject([

       { name:this.firstFile.fileName, filename: this.firstFile.fileName, data: imgdata }

      ])
      }, (error) => {

      }, () => {

        if(this.secondFile != null && this.secondFile != undefined && this.secondFile.fileLocation != "")
        {
          this.secondFile.isCreate =true;
          this.secondFile.isView =true;
          this.secondFile.isEdit =true;
          
          this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`,this.secondFile).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            
    
            var imgdata = this.base64ToArrayBuffer(data);
         
            this.dwvApp2.loadImageObject([
    
           { name:this.secondFile.fileName, filename: this.secondFile.fileName, data: imgdata }
    
          ])
          }, (error) => {
    
          }, () => {
          
          });
        }
      
      });
    }
   
  }

  
  /**
     * Get the tool names as a string array.
     */
  get toolNames(): string[] {
    return Object.keys(this.tools);
  }

  private base64ToArrayBuffer(base64) {

    var binaryString = atob(base64);

    var len = binaryString.length;

    var bytes = new Uint8Array(len);

    for (var i = 0; i < len; i++) {

        bytes[i] = binaryString.charCodeAt(i);

    }

    return bytes.buffer;

  }

  onClose(): void{
    this.close.emit();
  }

  /**
   * Handle a change tool event.
   * @param tool The new tool name.
   */
  onChangeTool = (tool: NgxSelectOption[]) => {


    if (this.dwvApp1 && tool != null && tool.length > 0) {
      this.selectedTool = tool[0].value as string;
      this.dwvApp1.setTool(this.selectedTool);
      if (this.selectedTool === 'Draw') {
        this.onChangeShape(this.drawTool);
      }
      if (this.selectedTool === 'Filter') {
        if (this.dwvApp1 && this.selectedTool === 'Filter') {
          this.dwvApp1.getToolboxController().setSelectedFilter(this.filterTool);
        }
      }
    }
  }

  onChangeToolWithname = (tool: string) => {


    if (this.dwvApp1 && tool != null && tool.length > 0) {
      this.selectedTool = tool;
      this.dwvApp1.setTool(this.selectedTool);
      if (this.selectedTool === 'Draw') {
        this.onChangeShape(this.drawTool);
      }
      if (this.selectedTool === 'Filter') {
        if (this.dwvApp1 && this.selectedTool === 'Filter') {
          this.dwvApp1.getToolboxController().setSelectedFilter(this.filterTool);

        }
      }
    }
  }

  onChangeFilter = (tool: string) => {

    this.selectedTool = 'Filter';
    if (this.dwvApp1 && tool != null && tool.length > 0) {

      if (this.selectedTool === 'Filter') {
        if (this.dwvApp1 && this.selectedTool === 'Filter') {
          this.filterTool = tool;
          this.dwvApp1.getToolboxController().setSelectedFilter(this.filterTool);

        }
      }
    }
  }

  onFilter(): void {
    if (this.dwvApp1 && this.selectedTool === 'Filter') {

      this.dwvApp1.setImageFilter(this.filterTool);
      this.dwvApp1.runImageFilter();
      this.dataRange = this.dwvApp1.getImage().getDataRange();
    }
  }

  onSliderChge(args: ChangeContext): void {

    this.dwvApp1.setFilterMinMax({ "min": args.value, "max": args.highValue });
  }
 
  


 
  
 
 
  onUndo(): void {
    this.dwvApp1.undo()
  }
  onRedo(): void {
    this.dwvApp1.redo()
  }

  /**
   * Handle a change draw shape event.
   * @param shape The new shape name.
   */
  private onChangeShape = (shape: string) => {
    this.selectedTool = 'Draw';
    if (this.dwvApp1 && this.selectedTool === 'Draw') {
      this.drawTool = shape;
      this.dwvApp1.setDrawShape(shape);
    }
  }

  /**
   * Handle a reset event.
   */
  onReset = () => {
    if (this.dwvApp1) {

      var drawList = this.dwvApp1.getDrawDisplayDetails();
      drawList.forEach(element => {
        this.dwvApp1.deleteDraws(element);
      });
      
      this.dwvApp1.resetDisplay();
      
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
  }

  get getApiUrl(): string{
    return environment.apiUrl;
  }

}
